module.exports = __webpack_public_path__ + "static/img/successRes.0ee2d45.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/successRes.png
// module id = aj6K
// module chunks = 56